exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 900px) {\n.w-file_edit {\n        max-width: 50vw;\n        min-width: 350px;\n}\n}\n@media (max-width: 900px) {\n.w-file_edit{\n        max-width: 70vw;\n        min-width: 250px;\n}\n}\n.btn-close{\n    opacity: .5;\n    position: absolute;\n    top: -10px;\n    right: -10px;\n}\n.btn-close:hover{\n    opacity: 1 !important;\n}\n", ""]);

// exports
